export default function Terms() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold">Terms & Conditions</h1>
      <p className="mt-4 text-slate-600">Please read these terms carefully.</p>
    </div>
  );
}















